import React from "react";
import ReactDOM from "react-dom/client";
import { AppProviders } from "./app/providers";
import { AppRouter } from "./app/router";
import "./assets/styles/theme.css";
import "./assets/styles/landing.css";
import "./assets/styles/artefacts.css";
import "./assets/styles/mobile.css";
import "./assets/styles/chat-polish.css";
import "./assets/styles/artefact-polish.css";
import "./assets/styles/chat-actions.css";
import "./assets/styles/forms.css";
import "./assets/styles/landing-story.css";
import "./assets/styles/landing-glass.css";
import "./assets/styles/auth-showcase.css";
// Last, on purpose: the one button system. See the header of buttons.css.
import "./assets/styles/buttons.css";
import { store } from "./app/store";
import { hydrateFromStorage } from "./features/auth/authSlice";

store.dispatch(hydrateFromStorage());

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <AppProviders>
            <AppRouter />
        </AppProviders>
    </React.StrictMode>
);
